"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidationRules = void 0;

var _validator = require("../validator");

var _clientsI18n = require("./clients-i18n");

var _messagesI18n = require("../messages-i18n");

var clientValidationRules = function clientValidationRules(_) {
  return [{
    attributes: ['name', 'id', 'accessTokenLifetimeSeconds', 'scopes', 'allowedGrantTypes'],
    condition: _validator.REQUIRED,
    message: function message(attribute) {
      return getRequiredErrorMessage(attribute, _);
    },
    on: ['create', 'update']
  }, {
    attributes: ['secret'],
    condition: _validator.REQUIRED,
    message: function message(attribute) {
      return getRequiredErrorMessage(attribute, _);
    },
    on: ['create']
  }, {
    attributes: ['accessTokenLifetimeSeconds'],
    condition: _validator.INTEGER,
    message: _(_clientsI18n.messages.mustBeAnInteger, {
      param: _(_clientsI18n.messages.accessTokenLifetimeSeconds)
    }),
    on: ['create', 'update']
  }, {
    attributes: ['allowedCorsOrigins'],
    condition: _validator.LIST,
    message: function message(attribute) {
      return getRequiredErrorMessage(attribute, _);
    },
    on: ['create', 'update'],
    listCondition: function listCondition(value) {
      return value ? /^https?:\/\/[a-zA-Z0-9.\-:]+$/.test(value) : true;
    }
  }];
};

var getRequiredErrorMessage = function getRequiredErrorMessage(attribute, _) {
  switch (attribute) {
    case 'name':
      return "".concat(_(_messagesI18n.messages.paramIsRequired, {
        param: _(_clientsI18n.messages.clientName)
      }));

    case 'id':
      return "".concat(_(_messagesI18n.messages.paramIsRequired, {
        param: 'ID'
      }));

    case 'allowedGrantTypes':
      return _(_clientsI18n.messages.atLeastOneGrantTypeIsRequired);

    case 'scopes':
      return "".concat(_(_messagesI18n.messages.paramsAreRequired, {
        params: _(_clientsI18n.messages.scopes)
      }));

    case 'accessTokenLifetimeSeconds':
      return "".concat(_(_messagesI18n.messages.paramIsRequired, {
        param: _(_clientsI18n.messages.accessTokenLifetimeSeconds)
      }));

    case 'secret':
      return "".concat(_(_messagesI18n.messages.paramIsRequired, {
        param: _(_clientsI18n.messages.clientSecret)
      }));

    case 'allowedCorsOrigins':
      return "".concat(_(_messagesI18n.messages.mustBeAValidUrl, {
        param: _(_clientsI18n.messages.allowedCors)
      }));

    default:
      return "".concat(_(_messagesI18n.messages.paramIsRequired, {
        param: attribute
      }));
  }
};

var getValidationRules = function getValidationRules(scenario, _) {
  return clientValidationRules(_).filter(function (rule) {
    return !rule.on || rule.on && rule.on.indexOf(scenario) !== -1;
  });
};

exports.getValidationRules = getValidationRules;
//# sourceMappingURL=validation-rules.js.map